import { SetPasswordForm } from '../common/components/organisims/LoginForms'

export const PageSetNewPassword = () => {
  return <SetPasswordForm />
}
